import { IRegisterKiwiSaverUser } from './../../models/registration/register';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { BaseHttpService } from './base.http.service';
import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/app.config';
import { IClientSearchModel } from 'src/app/store/client/reducers/client.reducers';
import { IEnvironmentConfig } from 'src/app/models/environmentConfig';
import { Product } from "../../models/orders";


@Injectable()
export class ClientService extends BaseHttpService {

    constructor(private http: HttpClient, private appConfig: AppConfig) {
        super();
    }

    get envSettings(): IEnvironmentConfig {
        return this.appConfig.getEnvironmentConfig();
    }

    // used by advisors for client search
    public getClientGroups(clientSearchModel: IClientSearchModel): Observable<any> {
        const encodedQuery = encodeURIComponent(clientSearchModel.query);

        let url = `${this.envSettings.webApiUrl}groupsummaries`;

        if (encodedQuery) {
            url += `?query=${encodedQuery}`;
        }

        if (clientSearchModel.entitySubType !== null) {
            url += encodedQuery ? `&entitySubType=${clientSearchModel.entitySubType}` : `?entitySubType=${clientSearchModel.entitySubType}`;
        }

        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    // used by advisors after client selection
    public getClientGroupEntities(groupEntityId: number, date: Date): Observable<any> {
        const queryDate = (date !== undefined) ? this.parseDate(date) : this.parseDate(new Date());
        const url = `${this.envSettings.webApiUrl}groupsummaries/${groupEntityId}?date=${queryDate}`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    // used by single investors for entity selection
    public getClientInvestorEntities(date: Date): Observable<any> {
        const queryDate = (date !== undefined) ? this.parseDate(date) : this.parseDate(new Date());
        const url = `${this.envSettings.webApiUrl}portfolios/investorentities?date=${queryDate}`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getSingleEntityPortfolioValue(entityId: number, date: Date): Observable<any> {
        const queryDate = (date !== undefined) ? this.parseDate(date) : this.parseDate(new Date());
        const url = `${this.envSettings.webApiUrl}portfolios/entity/${entityId}/netassetvalue/${queryDate}`;
        return this.http.get(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders()
        });
    }

    public getAvailablePositions(positionQuery: string, excludeNonTradeableSecurities = false): Observable<Product[]> {
        let url = `${this.envSettings.webApiUrl}products`;
        let params = new HttpParams();
        if(positionQuery !== '')
            params = params.set('query', positionQuery);
        if(excludeNonTradeableSecurities === true)
            params = params.set('excludeNonTradeableSecurities', excludeNonTradeableSecurities);
        
       return this.http.get<Product[]>(url, {
            observe: 'body',
            responseType: 'json',
            headers: this.getHttpHeaders(),
            params : params
        });
    }

    public getKiwiSaverEntity(): Observable<Partial<IRegisterKiwiSaverUser>> {
        const url = `${this.envSettings.webApiUrl}kiwisaver`;
        return this.http.get(url, {
            observe: "body",
            responseType: "json",
            headers: this.getHttpHeaders()
        });
    }
}

